import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Homepage from './page/Homepage';
import Header from './components/Header';
import Footer from './components/Footer';
import TechniquePage from './page/TechniquePage';

function App() {

  
  return (
    <>
    <BrowserRouter>
     <Header></Header>
        <Routes>
           <Route path='/' element={<Homepage />} />
           <Route path='/tech/:techniqueName' element={<TechniquePage />} />
        </Routes>
      <Footer></Footer>
    </BrowserRouter>
    </>
  );
  
}

export default App;
